import React from 'react';
import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonButton } from '@ionic/react';

// Components
import { MessageComponent } from './../../components';
import { TransactionSuccessOverlay } from '../transaction/TransactionSuccessOverlay';

// 4.1 Recibe transactionSummary
export const WebDetailMessageComponent = ({ showModal, handleFinish, message, subtitle, transactionSummary }) => {

    return (
        <>
            <IonContent className="ion-padding ion-text-center">

                <IonGrid>
                    <IonRow className='ion-text-left'>
                        <IonCol>
                            <h1>Status de la transacción</h1>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonCard>
                                <IonCardContent className="ion-text-center">

                                    {!showModal.error &&
                                        // 4.2 Reemplaza urlImage por TransactionSuccessOverlay cuando hay resumen
                                        <MessageComponent
                                            message={message}
                                            subtitle={<span className="text-success">{subtitle}</span>}
                                            urlImage={transactionSummary ? undefined : "assets/images/success.png"}
                                            svg={transactionSummary
                                                ? <TransactionSuccessOverlay
                                                    benefitType={transactionSummary.benefitType}
                                                    benefitTitle={transactionSummary.benefitTitle}
                                                    amount={transactionSummary.amount}
                                                    discountAmount={transactionSummary.discountAmount}
                                                    hasCalculableDiscount={transactionSummary.hasCalculableDiscount}
                                                />
                                                : undefined
                                            }
                                        >
                                            <IonButton
                                                type="button"
                                                color="primary"
                                                shape="round"
                                                size="undefined"
                                                onClick={handleFinish}>Generar otra transacción</IonButton>
                                        </MessageComponent>
                                    }

                                    {showModal.error &&
                                        <MessageComponent
                                            message={showModal.error}
                                            urlImage="assets/images/error.png"
                                            subtitle={<span className="text-error">Ha ocurrido un error.</span>}
                                        >
                                            <IonButton
                                                type="button"
                                                color="primary"
                                                shape="round"
                                                fill="outline"
                                                onClick={handleFinish}>Volver a intentar</IonButton>
                                        </MessageComponent>
                                    }

                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </IonContent>
        </>
    )
}
